var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85416 2H7.13864V2.5H3.85416V2Z",
    fill: "#27446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85416 3.5H7.13864V4H3.85416V3.5Z",
    fill: "#27446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4231 5.5V5H3.85416V5.5H10.4231Z",
    fill: "#27446F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4231 6.5V7H3.85416V6.5H10.4231Z",
    fill: "#27446F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4231 8.5V8H3.85416V8.5H10.4231Z",
    fill: "#27446F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4231 9.5V10H3.85416V9.5H10.4231Z",
    fill: "#27446F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21191 1.05882V10.9412C2.21191 11.5249 2.72202 12 3.34885 12H10.9284C11.5553 12 12.0654 11.5249 12.0654 10.9412V3.5L8.23347 0H3.34885C2.72202 0 2.21191 0.475059 2.21191 1.05882ZM8.23347 3.5V0.705872H3.34877C3.13995 0.705872 2.96979 0.864342 2.96979 1.05881V10.9412C2.96979 11.1356 3.13995 11.2941 3.34877 11.2941H10.9283C11.1372 11.2941 11.3073 11.1356 11.3073 10.9412V3.5H8.23347Z",
    fill: "#27446F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/Doc Icon.6ca72f3a15c1a5ef100bad8d10c454ed.svg";
export { ForwardRef as ReactComponent };